export default __webpack_public_path__ + "static/media/aws-ec2.a4b07562.svg";